import { render, staticRenderFns } from "./ReviewQuestions.vue?vue&type=template&id=bff3c650"
import script from "./ReviewQuestions.vue?vue&type=script&lang=js"
export * from "./ReviewQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports